import profilePic from "../assets/profile-pic.webp";
import InternalLink from "../components/InternalLink";
import { useLanguage } from "../localization/LanguageContext";
import { renderRichText } from "../localization/renderRichText";

function FrontPage()
{
    const { translation } = useLanguage();

    return (
        <div className="container d-flex flex-grow-1 justify-content-center align-items-center mt-5 mt-md-0">
            <div className="row gap-lg-4 align-items-center justify-content-center">
                <div className="col-8 col-md-5 col-lg-4 d-flex text-center mb-4 mb-md-0">
                    <img src={profilePic} alt="ProfilePicture" className="img-fluid rounded-circle"/>
                </div>
                <div className="col-md-7 col-lg-6 d-flex flex-column justify-content-center text-center text-md-start p-3">
                    <div className="display-3 text-nowrap mb-3  ">Dominik Navrátil</div>
                    <p className="fs-4">{renderRichText(translation("welcome_paragraph"), { projects: (label) => <InternalLink to="./my-projects">{label}</InternalLink>})}</p>
                </div>
            </div>
        </div>
    );
}

export default FrontPage;